function Shop_cart(element) {
  this.$element = $(element);

  this.selectors = {
    body: 'body',
    list: '.c-shop-cart__list',
    items: '.c-shop-cart__list-item',
    loader: '.c-shop-cart__loader',
    quantity: '.js-quantity',
    delete: '.js-delete',
    badge: '.c-shop-cart__icon-badge'
  };

  this.modifier = {
    loading: 'c-shop-cart--loading',
    badgeShown: 'c-shop-cart__icon-badge--shown'
  };

  this.triggers = {
    productAdded: 'i4-cart:added',
    productUpdated: 'i4-cart:updated',
    productDeleted: 'i4-cart:deleted'
  };

  this.ajaxCalls = {
    viewUpdate: 'view_update'
  };

  this.data = {
    cartId: 'cart-id',
    viewMode: 'view-mode',
    productPluginId: 'product-plugin-id',
    productId: 'product-id',

  };

  this.init = function () {

    this.$body = $(this.selectors.body);

    this.viewMode = this.$element.data(this.data.viewMode);
    this.viewMode = this.$element.data(this.data.viewMode);

    this.cartId = this.$element.data(this.data.cartId);

    switch (this.viewMode) {
      case 'tiny':
        this.$badge = this.$element.find(this.selectors.badge);
        break;
      case 'small':
      case 'full':

        this.$list = this.$element.find(this.selectors.list);
        this.$loader = this.$element.find(this.selectors.loader);

        break;
    }

    this.$body.on(this.triggers.productAdded, this.updateView.bind(this));
    this.$body.on(this.triggers.productUpdated, this.updateView.bind(this));
    this.$body.on(this.triggers.productDeleted, this.updateView.bind(this));

    this.updateView();
  };

  this.initItems = function () {
    if (this.viewMode === 'full') {
      this.$items = this.$element.find(this.selectors.items);

      this.$items.each((function (i, item) {
        const $item = $(item);

        $item.find(this.selectors.quantity).on('keyup', (function () {
          this.$onQuantityChange(item);
        }).bind(this));

        $item.find(this.selectors.delete).on('click', (function () {
          this.$onClickDelete(item);
        }).bind(this));

      }).bind(this));
    }
  };

  this.updateView = function (callback) {
    this.$element.addClass(this.modifier.loading);

    var parameter = $.extend({
      call: this.ajaxCalls.viewUpdate,
      cart_id: this.cartId,
      view_mode: this.viewMode
    }, i4_Cart_controller.options.ajaxParameter);

    i4_Ajax.factory().
    set_parameter(jQuery.param(parameter)).
    set_option({
      on_success: (function (response) {

        switch (this.viewMode) {
          case 'tiny':
            this.$badge.html(response);
            if (response > 0) {
              this.$badge.addClass(this.modifier.badgeShown);
            } else {
              this.$badge.removeClass(this.modifier.badgeShown);
            }
            break;
          case 'small':
            this.$list.html(response);
            this.$element.removeClass(this.modifier.loading);
            break;
          case 'full':
            this.$list.html(response);
            this.$element.removeClass(this.modifier.loading);
            this.initItems();
            break;
        }

      }).bind(this)
    }).
    run();
  };

  this.$onQuantityChange = function (item) {
    var $element = $(item);

    var $input = $element.find(this.selectors.quantity);
    var productId = $element.data(this.data.productId);
    var pluginId = $element.data(this.data.productPluginId);

    var value = $input.val();

    if (value === '') {
      $input.val(1);
      value = 1;
    }

    if (i4_Validator.isValidNumber(value, {})) {
      i4_Cart_controller.updateProduct(productId, {
        pluginId: pluginId,
        quantity: value
      });
    } else {
      $input.val(1);
    }
  };

  this.$onClickDelete = function (item) {
    var $element = $(item);
    var productId = $element.data(this.data.productId);
    var pluginId = $element.data(this.data.productPluginId);

    i4_Cart_controller.deleteProduct(productId, {
      pluginId: pluginId
    });
  };
}
